import React from 'react';
import {isEqual} from 'lodash';
import {connect} from 'react-redux'

// components
import Input from './Input'
import * as actions from "../../../store/actions";
import AlertCard from '../cards/AlertCard';


/*
* this must have five elements
*
* 1) Inputs that take data. One input type will be "custom", where you can pass it it's own react element
* 2) A submit button that has a custom handler
* 3) Substeps -- conditional logic that asks you more questions.
* 4) A data requirement -- what makes it such that we need to send the next one
* 5) An OnNext() method
* 6) An OnPrev() method
* */


/*

all inputs, their defaults and validator functions are
passed in through this.props.inputs.
 */

class StepForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    static defaultProps = {
        inputs: []
    };

    // only property names and their corresponding variables can live in state
    setStateFromInputProp = () => {

        const newState = this.props.inputs.reduce((r,d) => {
            r[d.dataKey + '_error'] = false;
            return r;
        }, {})
    }


    componentDidMount() {
        this.setStateFromInputProp();
        this.props.inputs.forEach(d => this.validateInput(d, this.state.dataKey))
    }


    componentDidUpdate(prevProps, prevState) {
        if (!isEqual(prevProps.inputs, this.props.inputs)
            || !isEqual(prevProps.inputs.map(d => d.value), this.props.inputs.map(d => d.value) )) {
            this.setStateFromInputProp()
        }

        if (!isEqual(prevProps.reset, this.props.reset)) {
            this.resetInputs();
        }
    }

    validateInput = (inputObject, val) => {
        if (inputObject.validator) {
            try {
                if (!inputObject.validator(val)) {
                    this.setState({[inputObject.dataKey + '_error']: true})
                } else {
                    this.setState({[inputObject.dataKey + '_error']: false})
                }
            } catch (e) {
                console.error("validation error", e)
            }
        }
    }

    // has the form been filled out at all?
    formHasValues = () => {
        return this.props.inputs.map(d => d.dataKey).some(d => this.state[d]);
    }

    formHasError = () => {

        if (this.props.customErrorCheck) return this.props.customErrorCheck(this.state);

        let hasError = false;
        for (let k in this.state) {
            if (!k.includes('_error')) continue;

            if (this.state[k]) {
                hasError = true;
                break;
            }
        }

        return hasError;
    }

    handleValueChange = (inputObject, val) => {
        this.validateInput(inputObject, val)
        this.props.updateInputs({[inputObject.dataKey]: val})
    }

    // make fields null, not blank, if we didn't put anything in them.
    getNullIfEmpty = (val) => {
        if ([undefined, null, NaN].includes(val)) {
            return null
        } if (String(val).length === 0) {
            return null
        } 
            return val;
        
    }





    renderInputs () {
        if (!this.props.inputs) return [];

        // if (this.props.customChild) return this.props.customChild

        return (
            <div className="box form-container-box">
                {this.props.inputs.map(d => ( d.type === 'alert' ?  // message allows for injec

                    <AlertCard
                            {...d}
                            type={d.alertType}
                            className={`form-alert my-3 ${d.className}`}
                        />
                    :

                    <Input
                        value={this.props.responses[d.dataKey]}
                        onChange={(val) => this.handleValueChange(d, val)}
                        key={d.dataKey}
                        inputClasses={`is-medium is-fullwidth ${d.inputClasses || ''}`}
                        {...d}
                    />
                ))}
            </div>
        )

    }

    render() {
        return (
            <div className="form-flow-step-wrapper">
                <div className="form-section-header">
                    {this.props.title}
                </div>

                {this.props.aboveFormComponent}

            <form  onSubmit={(ev) => ev.preventDefault()} action="#" autoComplete="off">
                    {this.renderInputs()}
            </form>
            </div>
        )
    }

}


const mapStateToProps = (state) => ({
    responses: state.formFlow.inputs,
    computed: state.formFlow.computed,
    currStep: state.formFlow.currStep,
})

const mapDispatchToProps = (dispatch) => ({
    updateInputs: data => dispatch(actions.formFlow.updateFormFlowInputs(data)),
    updateComputed: data => dispatch(actions.formFlow.updateFormFlowComputed(data)),

})

export default connect(mapStateToProps, mapDispatchToProps)(StepForm);
